import React from 'react'
import classNames from 'classnames'
import { bool, arrayOf, node, oneOfType, string } from 'prop-types'

const BlockComponents = ({
  isClickBlocked,
  hideContent,
  children,
  className,
  tooltipPositionClassname,
  blockMessage,
}) => {
  const blockClass = classNames({ isClickBlocked })
  const tooltipClassnameOrEmpty = className || ''
  const tooltipPositionClassnameOrDefault = tooltipPositionClassname || 'tooltipped-s'
  const notAllowedClass = classNames(
    'tooltipped tooltipped-multiline',
    tooltipPositionClassnameOrDefault,
    tooltipClassnameOrEmpty,
    {
      notAllowed: isClickBlocked,
    }
  )

  return hideContent ? null : isClickBlocked ? (
    <span className={notAllowedClass} aria-label={blockMessage}>
      <span className={blockClass}>{children}</span>
    </span>
  ) : (
    children
  )
}

BlockComponents.propTypes = {
  isClickBlocked: bool,
  hideContent: bool,
  children: oneOfType([arrayOf(node), node]),
  blockMessage: string,
}

BlockComponents.defaultProps = {
  isClickBlocked: false,
  hideContent: false,
  children: null,
  blockMessage: 'You don´t have access to this... yet! To view this content, upgrade your account.',
}

export default BlockComponents
